// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
/**
 * Update [[ViewManager]] in OccViewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    let aViewManager = theModule.viewManager;
    let aSubviewArray = [];
    Object.defineProperty(aViewManager, "subviews", {
        get: function () { return aSubviewArray; },
    });
    aViewManager.addSubviewObject = function (theSubview) {
        aSubviewArray = aSubviewArray.filter((theElem, theIndex, theArray) => {
            return theElem.id != theSubview.id;
        });
        aSubviewArray.push(theSubview);
    };
    aViewManager.findSubviewObject = function (theViewId) {
        return aSubviewArray.find((theElem, theIndex, theArray) => {
            return theElem.id == theViewId;
        });
    };
    let aCppRemoveSubview = aViewManager.removeSubview.bind(aViewManager);
    aViewManager.removeSubview = function (theViewId) {
        aSubviewArray = aSubviewArray.filter((theElem, theIndex, theArray) => {
            return theElem.id != theViewId;
        });
        aCppRemoveSubview(theViewId);
    };
    let aCppRemoveAllSubviews = aViewManager.removeAllSubviews.bind(aViewManager);
    aViewManager.removeAllSubviews = function () {
        let aSubviewToRemove = aSubviewArray.slice();
        aSubviewToRemove.reverse();
        aSubviewArray = [];
        aSubviewToRemove.forEach((theSubview) => {
            theSubview.remove(); // invalidate objects
        });
        aCppRemoveAllSubviews(); // should have no effect
    };
});
